import { siteData } from '@/mocks/siteData';

export default function AboutSection() {
  const { about } = siteData;

  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-label mb-3">
            <i className="ri-information-line"></i>关于黑料
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            {about.title}
          </h2>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-8">
            {about.stats.map((stat) => (
              <div key={stat.label} className="text-center p-4 rounded-xl bg-background-100">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs text-foreground-500 font-label">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>

          <div className="max-w-[700px] mx-auto">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {about.description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}